<template>
  <div class="layout-sider">
    <div class="sider-menu-index-logo">
      <img :src="logo" alt="logo">
      <h1>百年育才管理系统</h1>
    </div>
    <div class="sider-scrollbar">
      <Menu theme="dark" style="padding: 16px 0px" width="auto" accordion>
        <!-- <Submenu :name="catalogItem.menuId" v-for="catalogItem in $store.state.app.menuList" :key="catalogItem.menuId">
          <template slot="title">
            <Icon :type="catalogItem.menuIcon" size="18"/>{{catalogItem.menuName}}
          </template>
           <MenuItem :to="menuItem.menuRoute" :name="menuItem.menuId" v-for="menuItem in catalogItem.children" :key="menuItem.menuId">
            <Icon :type="menuItem.menuIcon" size="18"/>{{menuItem.menuName}}
          </MenuItem>
        </Submenu> -->
        <div v-for="(item, index) in $store.state.app.menuList" :key="index">
          <left-menu-item v-if="item.children && item.children.length!==0" :parent-item="item"></left-menu-item>
          <menu-item v-else :to="item.menuRoute" :name="item.menuId">
            <Icon :type="item.menuIcon" />
            <span>{{ item.menuName }}</span>
          </menu-item>
        </div>
      </Menu>
    </div>
  </div>
</template>
<script>
import logo from "~/assets/imgs/logo.png"
import LeftMenuItem from './LeftMenuItem'
export default {
  components: { LeftMenuItem },
  data() {
    return {
      logo: logo
    }
  }
}
</script>

<style lang="less">
.layout-sider {
  height: 100%;
  .sider-menu-index-logo {
    height: 64px;
    line-height: 64px;
    position: relative;
    padding-left: 24px;
    transition: all 0.3s;
    background: #002140;       // title背景色
    // background: #7D9EC0;
    box-shadow: 1px 1px 0 0 #e8e8e8;
    overflow: hidden;
    img {
      display: inline-block;
      vertical-align: middle;
      height: 32px;
    }
    h1 {
      color: #fff;
      display: inline-block;
      vertical-align: middle;
      font-size: 20px;
      margin: 0 0 0 12px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      font-weight: 600;
    }
  }
  .ivu-menu-light {
    background: transparent;
  }
  .ivu-menu-vertical.ivu-menu-light:after {
    width: 0px;
  }
  .ivu-menu-submenu-title-icon {
    transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    margin-right: -8px;
  }
  .ivu-menu-submenu-title-icon:after {
    transform: rotate(-45deg) translateX(2px);
  }
  .ivu-menu-submenu-title-icon:before {
    transform: rotate(-45deg) translateX(2px);
  }
  .sider-scrollbar {
    overflow-x: hidden;
    overflow-y: auto;
    background: #001529;
    // background: #9FB6CD;
    height: calc(100% - 64px);
    .ivu-menu-dark {
      background: #001529;           // 背景色
      // background: #9FB6CD;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
      background: #001529;           // 选中二级菜单时的所在一级菜单背景色
      // background: #9FB6CD;               
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
      background: #000c17;           // 选中二级菜单时的二级菜单背景色
      // background: #A2B5CD;
      box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.45);
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
      color: #fff;                   // 悬浮时文字颜色
      background: #001529;           // 悬浮时背景色
    //   background: #B0C4DE;
    //   color: #000
    }
    // .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title{
    //   color: #1A1A1A;
    // }
    // .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    //   background: #778899!important;
    // }
  }
  .sider-scrollbar::-webkit-scrollbar {
    display: none;
  }
}
</style>

